import style from './RenderTextField.module.scss';
import { InputAdornment, InputLabel, TextField } from '@material-ui/core';

interface IRenderTextFieldProps {
    id?: string;
    name?: string;
    type?: string;
    label?: any;
    inputMode?: string;
    value?: any;
    rows?: number;
    className?: string;
    variant?: any;
    placeholder?: string;
    autoComplete?: string;
    onFocus?: (e: object) => void;
    onInput?: (e: object) => void;
    onChange?: (e: object) => void;
    onBlur?: (e: object) => void;
    onKeyPress?: (e: object) => void;
    onPaste?: (e: object) => void;
    onKeyUp?: (e: object) => void;
    onKeyDown?: (e: object) => void;
    error?: boolean;
    readOnly?: boolean;
    multiline?: boolean;
    helperText?: string;
    defaultValue?: string;
    inputContainerClassName?: string;
    underLineClassName?: string;
    inputLabel?: string;
    inputStyle?: string;
    minRows?: number;
    maxlength?: number | string;
    autoFocus?: boolean;
    disabled?: boolean;
    hideInput?: boolean;
    startAdornment?: any;
    endAdornment?: any;
    inputComponent?: any;
    size?: any;
    min?: number | string;
    max?: number | string;
}

const RenderTextField = ({
    helperText,
    error,
    id,
    name,
    rows,
    multiline,
    type,
    readOnly,
    inputMode,
    label,
    value,
    className,
    variant,
    onChange,
    onFocus,
    onBlur,
    placeholder = '',
    autoComplete,
    defaultValue,
    min,
    max,
    inputLabel,
    inputStyle,
    autoFocus,
    onKeyPress,
    onPaste,
    onKeyUp,
    onKeyDown,
    disabled,
    inputContainerClassName,
    startAdornment,
    endAdornment,
    minRows,
    onInput,
    maxlength,
    hideInput,
    inputComponent,
    size,
    underLineClassName,

}: IRenderTextFieldProps) => {
    return (
        <div className={`${style.inputContainer} ${inputContainerClassName}`}>
            {!inputLabel ? (
                <InputLabel shrink htmlFor={id} className={style.inputLabels}>
                    {label}
                </InputLabel>
            ) : null}
            {!hideInput ? (
                <TextField
                    id={id}
                    name={name}
                    multiline={multiline}
                    rows={rows}
                    minRows={minRows}
                    error={error}
                    helperText={helperText}
                    type={type || 'text'}
                    variant={variant || 'outlined'}
                    value={value}
                    label={inputLabel}
                    disabled={disabled}
                    defaultValue={defaultValue}
                    size={size}
                    autoFocus={autoFocus}
                    InputProps={{
                        inputComponent,
                        type: type || 'text',
                        startAdornment: startAdornment ? (
                            <InputAdornment position="start">
                                {startAdornment}
                            </InputAdornment>
                        ) : null,
                        endAdornment: endAdornment ? (
                            <InputAdornment position="end">
                                {endAdornment}
                            </InputAdornment>
                        ) : null,
                        disabled: disabled,
                        //@ts-ignore
                        inputMode: inputMode || 'text',
                        readOnly,
                        inputProps: {
                            max,
                            min
                        },
                        maxLength: maxlength,
                        className: `${inputStyle} ${
                            disabled ? style.disabled : ''
                        }`
                    }}
                    placeholder={placeholder}
                    onInput={onInput}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    onPaste={onPaste}
                    onKeyUp={onKeyUp}
                    onKeyDown={onKeyDown}
                    onKeyPress={onKeyPress}
                    autoComplete={autoComplete}
                    classes={{ root: underLineClassName }}
                    className={`${className || style.inputFields} ${
                        multiline ? style.lineHeight25 : ''
                    }`}
                />
            ) : null}
        </div>
    );
};
export default RenderTextField;
